
    import '/opt/buildhome/repo/docs/spec/wake-up-ai-icon.en-US.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/docs/spec/wake-up-ai-icon.en-US.md?type=demo')
};